export default __webpack_public_path__ + "static/media/cat-ban.d2c16204.png";